import { useState, useEffect } from 'preact/hooks';
import { subscribeToPush, isPushSubscribed } from '../lib/pushManager';
import { IconBell } from './chorus';
import styles from './PushOptIn.module.css';

export function PushOptIn() {
  const [subscribed, setSubscribed] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    isPushSubscribed().then(setSubscribed);
  }, []);

  if (subscribed || dismissed || !('Notification' in window)) {
    return null;
  }

  const handleSubscribe = async () => {
    setLoading(true);
    const success = await subscribeToPush();
    setSubscribed(success);
    if (!success) setDismissed(true);
    setLoading(false);
  };

  return (
    <div class={styles.container}>
      <div class={styles.iconWrap} aria-hidden="true">
        <IconBell />
      </div>
      <div class={styles.body}>
        <p class={styles.title}>Notify me when…</p>
        <p class={styles.description}>
          Ping when someone adds a take. Recommended.
        </p>
      </div>
      <div class={styles.actions}>
        <button onClick={handleSubscribe} disabled={loading} class={styles.subscribeButton}>
          {loading ? 'Setting up…' : 'Allow'}
        </button>
        <button onClick={() => setDismissed(true)} class={styles.dismissButton}>
          Not now
        </button>
      </div>
    </div>
  );
}
